import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence, animate } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

// Lüks Dijital Sayaç Efekti (Animated Number)
function AnimatedNumber({ value }: { value: number }) {
  const nodeRef = useRef<HTMLSpanElement>(null);
  
  useEffect(() => {
    const node = nodeRef.current;
    if (node) {
      const initial = parseInt(node.textContent || '0', 10);
      const controls = animate(initial, value, {
        duration: 0.8,
        ease: "easeOut",
        onUpdate(v) {
          node.textContent = Math.round(v).toString();
        }
      });
      return controls.stop;
    }
  }, [value]);
  
  return <span ref={nodeRef}>{value}</span>;
}

const initialPlans = [
  {
    id: '2-1',
    title: '2+1 Örnek Daire',
    area: 95,
    rooms: '2 Yatak Odası + 1 Salon',
    image: '/tk-int-4.png',
    blueprint: '/plan-2-1.png',
    description: '2+1 daire tipimiz, modern yaşam alanları arayanlar için ideal bir seçenektir. Geniş salon alanı, fonksiyonel mutfak ve konforlu yatak odaları ile ailenizin tüm ihtiyaçlarını karşılayacak şekilde tasarlanmıştır.',
    roomDetails: [
      { name: 'Salon', area: '24 m²' },
      { name: 'Mutfak', area: '10 m²' },
      { name: 'Ana Yatak Odası', area: '14 m²' },
      { name: 'Balkon', area: '12 m²' }
    ],
    features: ['Geniş ve ferah salon', 'Açık mutfak konsepti', 'Ana yatak odasına özel banyo', 'Doğal ışık alan tasarım']
  },
  {
    id: '2-1-garden',
    title: '2+1 Bahçe Katı',
    area: 110,
    rooms: '2 Yatak Odası + 1 Salon + Bahçe',
    image: '/tk-int-ref-1.png',
    blueprint: '/plan-2-1-garden.png',
    description: 'Doğayla iç içe bir yaşam sunan bahçe katı dairelerimiz, size özel yeşil alanlarıyla müstakil ev konforu yaşatır. Sabah kahvelerinizi kendi bahçenizde içmenin keyfine varın.',
    roomDetails: [
      { name: 'Salon', area: '26 m²' },
      { name: 'Mutfak', area: '12 m²' },
      { name: 'Yatak Odası', area: '15 m²' },
      { name: 'Bahçe Terası', area: '25 m²' }
    ],
    features: ['Özel bahçe kullanım alanı', 'Müstakil giriş hissi', 'Doğa ile iç içe yaşam', 'Geniş peyzaj manzarası']
  },
  {
    id: '3-1',
    title: '3+1 Klasik Aile',
    area: 125,
    rooms: '3 Yatak Odası + 1 Salon',
    image: '/tk-int-1.png',
    blueprint: '/plan-3-1.png',
    description: 'Geniş aileler için tasarlanmış 3+1 daire tipimiz, konforlu ve fonksiyonel bir yaşam sunar. Ebeveyn giyinme odası, geniş balkonlar ve ferah odalar klasik aile yaşantısına lüks katıyor.',
    roomDetails: [
      { name: 'Salon', area: '32 m²' },
      { name: 'Mutfak', area: '14 m²' },
      { name: 'Ebeveyn Süiti', area: '18 m²' },
      { name: 'Giyinme Odası', area: '6 m²' }
    ],
    features: ['Ebeveyn süiti ve banyosu', 'Giyinme odası alanı', 'Geniş çift balkon', 'Ayrı çamaşır odası']
  },
  {
    id: '3-1-terrace',
    title: '3+1 Panoramik Teras',
    area: 145,
    rooms: '3 Yatak Odası + 1 Salon + Dev Teras',
    image: '/yapsat-realistic-3.png',
    blueprint: '/plan-3-1-terrace.png',
    description: 'Gökyüzü konforunu evinize taşıyan bu özel plan, devasa panoromik terası ile şehri ve peyzajı ayaklarınızın altına seriyor. Lüks bir loft hissi arayanlar için tasarlandı.',
    roomDetails: [
      { name: 'Salon', area: '35 m²' },
      { name: 'Mutfak', area: '16 m²' },
      { name: 'Panoramik Teras', area: '45 m²' },
      { name: 'Ana Yatak Odası', area: '20 m²' }
    ],
    features: ['Devasa panoramik teras', 'Geniş sürgülü sistem camlar', 'Açık hava jakuzi altyapısı', 'Ahşap teras zemin detayları']
  },
  {
    id: '3-1-duplex',
    title: '3+1 Dubleks',
    area: 155,
    rooms: '3 Yatak Odası + 1 Salon + Dubleks',
    image: '/yapsat-int-3.png',
    blueprint: '/plan-3-1-duplex.png',
    description: 'İki katlı özel yaşam alanı arayanlar için kusursuz bir mimari bütünlük. Alt katta geniş sosyal alanlar yer alırken, üst katta tamamen izole edilmiş mahrem ve rahat yatak odaları bulunur.',
    roomDetails: [
      { name: 'Salon (Alt Kat)', area: '40 m²' },
      { name: 'Mutfak (Alt Kat)', area: '18 m²' },
      { name: 'Ebeveyn Süiti', area: '28 m²' },
      { name: 'Ebeveyn Terası', area: '15 m²' }
    ],
    features: ['İki katlı müstakil yaşam hissi', 'Üst katta dev ebeveyn süiti', 'Galeri boşluklu modern mimari', 'Özel tasarım ahşap merdiven']
  },
  {
    id: '4-1',
    title: '4+1 Ekstra Geniş',
    area: 165,
    rooms: '4 Yatak Odası + 1 Salon',
    image: '/yapsat-int-2.png',
    blueprint: '/plan-4-1.png',
    description: 'KARE YAPI\'nın en prestijli konut tiplerinden biri. Hem kalabalık aileler, hem de evde özel bir çalışma alanı isteyenler için maksimum büyüklükte optimize edildi.',
    roomDetails: [
      { name: 'Dev Salon', area: '45 m²' },
      { name: 'Ada Mutfak', area: '22 m²' },
      { name: 'Master Süit', area: '30 m²' },
      { name: 'Misafir Odası', area: '12 m²' }
    ],
    features: ['Devasa ada mutfak', 'Özel çalışma odası', '3 adet tam donanımlı banyo', 'Kat holüne özel kiler alanı']
  }
];

export default function FloorPlansPage() {
  const [plans, setPlans] = useState<any[]>(initialPlans);
  const [activePlanIdx, setActivePlanIdx] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    const unsub = onSnapshot(doc(db, 'pages', 'floorplans'), (doc) => {
      if (doc.exists() && doc.data().items && doc.data().items.length > 0) {
        
        const dbItems = doc.data().items.map((dbPlan: any) => {
           const defaultPlan = initialPlans.find(p => p.id === dbPlan.id);
           
           if (!defaultPlan) return dbPlan;

           // Eğer DB'den gelen açıklama 3 nokta ile biten o sahte metinse, orijinal uzun metne geç
           const isCorruptDesc = dbPlan.desc && (dbPlan.desc.includes('...') || dbPlan.desc.length < 50);
           const finalDesc = isCorruptDesc ? defaultPlan.description : (dbPlan.desc || defaultPlan.description);

           return {
             ...dbPlan,
             description: finalDesc, // Use description to match frontend expectations
             desc: finalDesc,
             title: dbPlan.title || defaultPlan.title,
             net: dbPlan.net || defaultPlan.area,
             gross: dbPlan.gross || defaultPlan.area,
             image: dbPlan.image || defaultPlan.image,
             blueprint: dbPlan.blueprint || defaultPlan.blueprint,
             roomDetails: dbPlan.roomDetails || defaultPlan.roomDetails,
             features: dbPlan.features || defaultPlan.features
           };
        });

        // Eğer 6'dan az plan varsa, eksikleri tamamla
        const mergedItems = [...dbItems];
        initialPlans.forEach(fp => {
          if (!mergedItems.find(m => m.id === fp.id)) {
            mergedItems.push(fp);
          }
        });
        mergedItems.sort((a, b) => initialPlans.findIndex(fp => fp.id === a.id) - initialPlans.findIndex(fp => fp.id === b.id));

        setPlans(mergedItems);
        setActivePlanIdx(0); // Reset to first plan on update
      }
    });

    return () => unsub();
  }, []);

  const activePlan = plans[activePlanIdx];

  if (!activePlan) return null; // Safe guard

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 selection:bg-red-500 selection:text-white">
      <Navbar />
      
      {/* Dashboard Lüks Başlık */}
      <div className="pt-24 pb-8 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <nav className="flex items-center gap-2 text-sm text-gray-500 mb-4">
              <Link to="/" className="hover:text-red-600 transition-colors">Ana Sayfa</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-gray-900 font-medium">İnteraktif Kat Planları</span>
            </nav>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: 'Raleway, sans-serif' }}>
              Projeleri Keşfedin
            </h1>
            <p className="text-gray-500 mt-2 text-lg">Seçimlerinizi yapın, hayalinizdeki evi interaktif olarak taslaklarda gezin.</p>
          </div>
          
          {/* İletişim Yönlendirmesi */}
          <Link to="/contact" className="inline-flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-xl font-bold hover:bg-red-600 transition-colors">
            <i className="ri-phone-line"></i> Satış Ekibine Ulaşın
          </Link>
        </div>
      </div>

      {/* Ana İnteraktif Dashboard */}
      <div className="flex-1 py-12 max-w-7xl mx-auto px-4 lg:px-8 w-full">
        
        {/* Seçici Butonlar (Sekmeler) */}
        <div className="bg-white p-2 rounded-2xl shadow-sm border border-gray-100 flex flex-wrap gap-2 mb-12">
          {plans.map((plan, idx) => {
            const isActive = activePlanIdx === idx;
            return (
              <button
                key={plan.id}
                onClick={() => setActivePlanIdx(idx)}
                className={`flex-1 min-w-[140px] py-4 px-4 rounded-xl font-semibold text-sm transition-all duration-300 ${
                  isActive 
                    ? 'bg-red-600 text-white shadow-lg shadow-red-600/30 -translate-y-1' 
                    : 'bg-gray-50 text-slate-600 hover:bg-gray-100 hover:text-slate-900'
                }`}
              >
                {plan.title}
              </button>
            );
          })}
        </div>

        {/* Dinamik İçerik Alanı */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Sol Kolon: Görüntü (Render / Çizim) */}
          <div className="lg:col-span-8 bg-white rounded-3xl p-4 shadow-xl shadow-slate-200/50 border border-slate-100 relative overflow-hidden min-h-[500px]">
             {/* Filigran */}
             <div className="absolute top-10 right-10 text-[120px] font-black text-slate-50 leading-none select-none z-0">
               {activePlan.id.split('-').join('+')}
             </div>
             
             <AnimatePresence mode="wait">
                <motion.div
                  key={activePlan.id}
                  initial={{ opacity: 0, x: -30, filter: "blur(10px)" }}
                  animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                  exit={{ opacity: 0, x: 30, filter: "blur(10px)" }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  className="relative z-10 w-full h-full flex items-center justify-center p-4"
                >
                  <img 
                    src={activePlan.image} 
                    alt={activePlan.title} 
                    className="max-w-full max-h-[600px] object-contain drop-shadow-2xl rounded-xl"
                  />
                </motion.div>
             </AnimatePresence>
          </div>

          {/* Sağ Kolon: Dijital Gösterge Paneli */}
          <div className="lg:col-span-4 space-y-8">
            
            {/* Büyük Sayaç Kartı */}
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 text-white shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 p-6 opacity-10">
                <i className="ri-ruler-2-line text-8xl"></i>
              </div>
              <h3 className="text-slate-400 font-medium mb-2 uppercase tracking-widest text-sm">Toplam Brüt Alan</h3>
              <div className="text-6xl font-bold flex items-baseline gap-2 mb-2" style={{ fontFamily: 'Raleway, sans-serif' }}>
                <AnimatedNumber value={parseInt(activePlan.gross || activePlan.area || '0')} /> <span className="text-3xl font-light text-red-500">m²</span>
              </div>
              <div className="w-12 h-1 bg-red-600 rounded-full my-6"></div>
              
              <AnimatePresence mode="wait">
                <motion.div
                   key={activePlan.id}
                   initial={{ opacity: 0, y: 10 }}
                   animate={{ opacity: 1, y: 0 }}
                   exit={{ opacity: 0, y: -10 }}
                   transition={{ duration: 0.4 }}
                >
                  <div className="flex items-center gap-3 text-lg font-medium text-slate-200">
                    <i className="ri-layout-line text-red-500 text-2xl"></i>
                    {activePlan.title}
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Oda Özellikleri ve Detaylar */}
            <div className="bg-white rounded-3xl p-8 shadow-xl shadow-slate-200/50 border border-slate-100">
              <AnimatePresence mode="wait">
                <motion.div
                   key={activePlan.id + "-details"}
                   initial={{ opacity: 0 }}
                   animate={{ opacity: 1 }}
                   exit={{ opacity: 0 }}
                   transition={{ duration: 0.5 }}
                >
                  <h4 className="text-xl font-bold text-slate-900 mb-4 tracking-tight">Oda Detayları</h4>
                  <div className="space-y-3 mb-8">
                    {activePlan.roomDetails ? activePlan.roomDetails.map((room: any, i: number) => (
                      <div key={i} className="flex justify-between items-center py-2 border-b border-slate-100 last:border-0">
                        <span className="text-slate-600 font-medium">{room.name}</span>
                        <span className="font-bold text-slate-900 bg-slate-50 px-3 py-1 rounded-lg">{room.area}</span>
                      </div>
                    )) : (
                      <>
                        <div className="flex justify-between items-center py-2 border-b border-slate-100">
                          <span className="text-slate-600 font-medium">Net Kullanım Alanı</span>
                          <span className="font-bold text-slate-900 bg-slate-50 px-3 py-1 rounded-lg">{activePlan.net || 'N/A'} m²</span>
                        </div>
                        <div className="flex justify-between items-center py-2 border-b border-slate-100">
                          <span className="text-slate-600 font-medium">Brüt Yüzölçümü</span>
                          <span className="font-bold text-slate-900 bg-slate-50 px-3 py-1 rounded-lg">{activePlan.gross || 'N/A'} m²</span>
                        </div>
                      </>
                    )}
                  </div>

                  <h4 className="text-xl font-bold text-slate-900 mb-4 tracking-tight">Premium Özellikler</h4>
                  <ul className="space-y-3">
                    {(activePlan.features || ['Yüksek Tavanlı Ferah Mimari', 'Birinci Sınıf Malzeme ve İşçilik', 'Akıllı Ev Altyapısı', 'Isı ve Ses İzolasyonu']).map((feature: string, i: number) => (
                      <li key={i} className="flex items-start gap-3">
                        <div className="w-6 h-6 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-red-600 text-sm"></i>
                        </div>
                        <span className="text-slate-600 leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <div className="mt-8 pt-6 border-t border-slate-100">
                    <p className="text-sm text-slate-500 italic leading-relaxed">
                      {activePlan.desc || activePlan.description}
                    </p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

          </div>
        </div>

        {/* --- TEKNİK ÇİZİM (KROKİ) ALANI --- */}
        <div className="mt-16 bg-white rounded-3xl p-8 lg:p-12 shadow-xl shadow-slate-200/50 border border-slate-100 relative overflow-hidden">
             <div className="text-center mb-10">
               <h3 className="text-3xl font-bold text-slate-900 tracking-tight mb-2" style={{ fontFamily: 'Raleway, sans-serif' }}>Mimari Kat Planı (Kroki)</h3>
               <p className="text-slate-500">Seçili daire tipine ait detaylı teknik yerleşim ve metrekare dağılımları.</p>
               <div className="w-16 h-1 bg-red-600 mx-auto mt-6 rounded-full"></div>
             </div>
             
             <div className="bg-slate-50 rounded-2xl p-4 md:p-8 flex items-center justify-center min-h-[400px] border border-slate-100">
               <AnimatePresence mode="wait">
                  <motion.div
                    key={activePlan.id + "-blueprint"}
                    initial={{ opacity: 0, scale: 0.95, filter: "blur(5px)" }}
                    animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                    exit={{ opacity: 0, scale: 1.05, filter: "blur(5px)" }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="w-full flex justify-center"
                  >
                    <img 
                      src={activePlan.blueprint} 
                      alt={activePlan.title + " Teknik Çizim"} 
                      className="max-w-full max-h-[700px] object-contain mix-blend-multiply drop-shadow-xl"
                    />
                  </motion.div>
               </AnimatePresence>
             </div>
        </div>

      </div>

      <Footer />
    </div>
  );
}